import { EntryRowProps, EntryRowTypeHelpers } from 'common/query-builder/query-entry-section/row-types/types';
import { EntryPart, MetricEntry } from 'common/query-builder/query-entry-section/types';
import * as BookmarkTypes from 'common/types/reports/bookmark';
import { getFormulaValidationError } from 'common/report/insights/contexts/formula-utils';
import { NewMetricEntryRow } from './index';
import { getNewSimpleMetricEntry } from './utils';
import type { RowProps } from './types/catalog';
export function isPlaceholder(props: RowProps | EntryRowProps<MetricEntry>): boolean {
  if (props.entry.type === BookmarkTypes.TopLevelMetricType.NewFormulaEntry) {
    const error = getFormulaValidationError({
      metric: props.entry,
      definition: props.entry.definition,
      globalMetrics: props.getEntries(false) as MetricEntry[]
    });
    return props.entry.definition === "" || Boolean(error);
  }

  // forces placeholder data onto the bookmark itself
  return false;
}
export const helpers: EntryRowTypeHelpers<MetricEntry> = {
  component: NewMetricEntryRow,
  getNewEntry: () => {
    return getNewSimpleMetricEntry({
      isExpanded: true
    });
  },
  isPlaceholder,
  getDefaultActiveEntryPart: () => {
    return EntryPart.Value;
  }
};